const GAME_BADGE_TRANSLATION_KEYS = [
  "game.label_trending",
  "game.label_hot",
  "game.label_new",
  "game.label_high-roller",
] as const;

const GAME_CARD_HOVER_TRANSLATION_KEYS = [
  "general.deposit_to_play",
  "general.open_the_game",
] as const;

const GAME_CARD_TRANSLATION_KEYS = [
  ...GAME_BADGE_TRANSLATION_KEYS,
  ...GAME_CARD_HOVER_TRANSLATION_KEYS,
] as const;

type GameCardTranslationKey = (typeof GAME_CARD_TRANSLATION_KEYS)[number];
type GameCardTranslations = Partial<Record<GameCardTranslationKey, string>>;

export {
  GAME_BADGE_TRANSLATION_KEYS,
  GAME_CARD_HOVER_TRANSLATION_KEYS,
  GAME_CARD_TRANSLATION_KEYS,
  type GameCardTranslations,
};
